import { getDatadogConfig } from '../lib/datadog';

export function DatadogStatusBanner() {
  // Only show in development mode
  if (process.env.NODE_ENV !== 'development') return null;

  const config = getDatadogConfig();

  if (!config) {
    return (
      <div style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        backgroundColor: '#fee',
        borderTop: '1px solid #fcc'
      }}>
        <div style={{
          maxWidth: '1800px',
          margin: '0 auto',
          padding: '8px 16px'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            fontSize: '14px',
            color: '#c00'
          }}>
            {/* Alert Circle Icon */}
            <svg
              style={{ width: '16px', height: '16px', flexShrink: 0 }}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <circle cx="12" cy="12" r="10" strokeWidth="2" />
              <line x1="12" y1="8" x2="12" y2="12" strokeWidth="2" strokeLinecap="round" />
              <line x1="12" y1="16" x2="12.01" y2="16" strokeWidth="2" strokeLinecap="round" />
            </svg>
            <span style={{ fontWeight: '500' }}>Datadog RUM Not Configured</span>
            <span style={{ color: '#a00' }}>
              - Set REACT_APP_DATADOG_APPLICATION_ID, REACT_APP_DATADOG_CLIENT_TOKEN, and REACT_APP_DATADOG_SITE in your .env file
            </span>
          </div>
        </div>
      </div>
    );
  }

  const maskToken = (token) => {
    if (token.length <= 4) return '****';
    return '...' + token.slice(-4);
  };

  const maskAppId = (appId) => {
    if (appId.length <= 4) return '****';
    return '...' + appId.slice(-4);
  };

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 9999,
      backgroundColor: '#efe',
      borderTop: '1px solid #cec'
    }}>
      <div style={{
        maxWidth: '1800px',
        margin: '0 auto',
        padding: '8px 16px'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '16px',
          fontSize: '14px',
          color: '#060'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            {/* Check Circle Icon */}
            <svg
              style={{ width: '16px', height: '16px', flexShrink: 0 }}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <circle cx="12" cy="12" r="10" strokeWidth="2" />
              <path d="M9 12l2 2 4-4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <span style={{ fontWeight: '500' }}>Datadog RUM Active</span>
          </div>
          <span style={{ color: '#050' }}>
            Service: <span style={{ fontFamily: 'monospace' }}>{config.service}</span>
          </span>
          <span style={{ color: '#050' }}>
            Environment: <span style={{ fontFamily: 'monospace' }}>{config.env}</span>
          </span>
          <span style={{ color: '#050' }}>
            Site: <span style={{ fontFamily: 'monospace' }}>{config.site}</span>
          </span>
          <span style={{ color: '#050' }}>
            App ID: <span style={{ fontFamily: 'monospace' }}>{maskAppId(config.applicationId)}</span>
          </span>
          <span style={{ color: '#050' }}>
            Token: <span style={{ fontFamily: 'monospace' }}>{maskToken(config.clientToken)}</span>
          </span>
        </div>
      </div>
    </div>
  );
}
